import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { arrayMove, compose } from '@elliemae/ds-utilities/utils';
import withProviders from './withProviders.js';
import { navigateTo, resetCheckedItems, resetMovedItems, addToTarget, removeFromTarget, toggleItemSelection } from './Shuttle.actions.js';
import { pipe, getItemsById, getActiveIdFromHierarchy, filterBySearch, filterMovedItems, getChildrenFromParent } from './helper.js';
import ShuttleRenderer from './ShuttleRenderer.js';
import SearchState from './SearchState.js';
import updateShuttleStateFromProps from './updateShuttleStateFromProps.js';
import './AnimationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';
import './ShuttleState.js';
import 'treetabular';
import './utils.js';
import './components/ShuttleSource.js';
import 'prop-types';
import '@elliemae/ds-icons/ArrowShortRight';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/Search';
import './components/ShuttleSearchBox.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/form/TextBox';
import './components/ShuttleInfiniteScrollIndicator.js';
import '@elliemae/ds-basic/IndeterminateProgressIndicator';
import './components/ShuttleListItem/ShuttleSourceListItem.js';
import './components/ShuttleListItem/ActionButtons.js';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortReturn';
import './components/ShuttleListItem/ShuttleListItem.js';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/TruncatedTooltipText';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import './classedComponents.js';
import './components/ShuttleBreadcrumb.js';
import '@elliemae/ds-basic/Breadcrumb';
import './animation/animationConfig.js';
import './components/OverflowList.js';
import './components/ShuttleListPanel.js';
import './components/VirtualizedList.js';
import 'react-window';
import 'react-window-infinite-loader';
import 'react-virtualized-auto-sizer';
import './components/VirtualizedItem.js';
import './components/VirtualizedSortableList.js';
import './components/LoadingIndicator.js';
import '@elliemae/ds-basic/CircularProgressIndicator';
import 'styled-components';
import './components/ShuttleTarget.js';
import './components/ShuttleListItem/ShuttleTargetListItem.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ShuttleImpl = /*#__PURE__*/function (_Component) {
  _inherits(ShuttleImpl, _Component);

  var _super = _createSuper(ShuttleImpl);

  function ShuttleImpl(props) {
    var _this;

    _classCallCheck(this, ShuttleImpl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getState", function () {
      var movedItems = _this.state.movedItems;
      return Object.keys(movedItems);
    });

    _this.state = {
      prevProps: {},
      preparedItems: [],
      checkedItems: [],
      // left breadcrumb
      hierarchy: [{
        name: props.sourceRootTitle,
        id: null
      }],
      // right breadcrumb
      hierarchyDest: [{
        name: props.targetRootTitle,
        id: null
      }],
      movedItems: [],
      sourceItems: [],
      targetItems: []
    };
    _this.toggleItemSelection = _this.toggleItemSelection.bind(_assertThisInitialized(_this));
    _this.resetCheckedItems = _this.resetCheckedItems.bind(_assertThisInitialized(_this));
    _this.resetMovedItems = _this.resetMovedItems.bind(_assertThisInitialized(_this));
    _this.moveCheckedItems = _this.moveCheckedItems.bind(_assertThisInitialized(_this));
    _this.handleTargetSortEnd = _this.handleTargetSortEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ShuttleImpl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var setGetStatus = this.props.setGetStatus;
      setGetStatus(this.getState);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var onChange = this.props.onChange;
      var movedItems = this.state.movedItems;
      onChange(Object.keys(movedItems));
    }
  }, {
    key: "navigate",
    value: function navigate(item, dest, direction) {
      var _this$props = this.props,
          onDrillDown = _this$props.onDrillDown,
          onDrillDownTarget = _this$props.onDrillDownTarget;
      if (!dest) onDrillDown(item, direction);
      if (dest) onDrillDownTarget(item, direction);
      var resetSearchState = this.context.reset;
      resetSearchState();
      this.setState(pipe([navigateTo(item, dest), resetCheckedItems()]));
    }
  }, {
    key: "resetCheckedItems",
    value: function resetCheckedItems$1() {
      this.setState(resetCheckedItems());
    }
  }, {
    key: "resetMovedItems",
    value: function resetMovedItems$1() {
      var _this2 = this;

      var _this$props2 = this.props,
          selectedItems = _this$props2.selectedItems,
          onRemoveAllFromTarget = _this$props2.onRemoveAllFromTarget;

      if (!selectedItems) {
        this.setState(pipe([navigateTo({
          id: null
        }, true), resetMovedItems()]), function () {
          _this2.handleChange();
        });
      } else {
        this.setState(pipe([navigateTo({
          id: null
        }, true)]));
      }

      onRemoveAllFromTarget();
    }
  }, {
    key: "addToTarget",
    value: function addToTarget$1(item) {
      var _this3 = this;

      var _this$props3 = this.props,
          selectedItems = _this$props3.selectedItems,
          onAddToTarget = _this$props3.onAddToTarget;

      if (!selectedItems) {
        this.setState(pipe([addToTarget(item), resetCheckedItems()]), function () {
          _this3.handleChange();
        });
      }

      onAddToTarget(item);
    }
  }, {
    key: "removeFromTarget",
    value: function removeFromTarget$1(item) {
      var _this4 = this;

      var _this$props4 = this.props,
          selectedItems = _this$props4.selectedItems,
          onRemoveFromTarget = _this$props4.onRemoveFromTarget;

      if (!selectedItems) {
        this.setState(pipe([removeFromTarget(item)]), function () {
          _this4.handleChange();
        });
      }

      onRemoveFromTarget(item);
    }
  }, {
    key: "toggleItemSelection",
    value: function toggleItemSelection$1(item) {
      this.setState(toggleItemSelection(item.id));
    }
  }, {
    key: "moveCheckedItems",
    value: function moveCheckedItems() {
      var _this5 = this;

      var _this$props5 = this.props,
          onAddCheckedItems = _this$props5.onAddCheckedItems,
          selectedItems = _this$props5.selectedItems,
          nonSelectedItems = _this$props5.nonSelectedItems;
      var _this$state = this.state,
          checkedItems = _this$state.checkedItems,
          preparedItems = _this$state.preparedItems;
      var isControlledV2 = !!selectedItems && !!nonSelectedItems;
      var checked = isControlledV2 ? nonSelectedItems.filter(function (item) {
        return checkedItems.some(function (check) {
          return check === item;
        });
      }) : checkedItems;
      var items = getItemsById(checked, preparedItems);
      var actions = !selectedItems ? items.map(function (item) {
        return addToTarget(item);
      }) : [];
      this.setState(pipe([].concat(_toConsumableArray(actions), [resetCheckedItems()])), function () {
        _this5.handleChange();
      });
      onAddCheckedItems(items);
    }
  }, {
    key: "handleTargetSortEnd",
    value: function handleTargetSortEnd(_ref) {
      var sourceItem = _ref.sourceItem,
          targetItem = _ref.targetItem;
      var _this$props6 = this.props,
          idField = _this$props6.idField,
          onTargetSortEnd = _this$props6.onTargetSortEnd;
      var _this$state2 = this.state,
          targetItems = _this$state2.targetItems,
          hierarchyDest = _this$state2.hierarchyDest,
          movedItems = _this$state2.movedItems;
      var hierarchyId = getActiveIdFromHierarchy(hierarchyDest).id;
      var collection = !hierarchyId ? movedItems : targetItems;
      var oldIndex = collection.findIndex(function (tItem) {
        return tItem[idField] === sourceItem[idField];
      });
      var newIndex = collection.findIndex(function (tItem) {
        return tItem[idField] === targetItem[idField];
      });
      var sortedMovedItems = !hierarchyId ? arrayMove(movedItems, oldIndex, newIndex) : movedItems;
      var sortedItems = hierarchyId ? arrayMove(targetItems, oldIndex, newIndex) : targetItems;
      this.setState({
        targetItems: sortedItems,
        movedItems: sortedMovedItems
      });
      onTargetSortEnd({
        sourceItem: sourceItem,
        targetItem: targetItem
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props7 = this.props;
          _this$props7.idField;
          var nonSelectedItems = _this$props7.nonSelectedItems,
          moreItemsLoading = _this$props7.moreItemsLoading,
          rest = _objectWithoutProperties(_this$props7, ["idField", "nonSelectedItems", "moreItemsLoading"]);

      var _this$state3 = this.state,
          hierarchy = _this$state3.hierarchy,
          hierarchyDest = _this$state3.hierarchyDest,
          checkedItems = _this$state3.checkedItems,
          movedItems = _this$state3.movedItems,
          items = _this$state3.preparedItems,
          targetItems = _this$state3.targetItems;
      var _this$context$state = this.context.state,
          searchTerm = _this$context$state.searchTerm,
          searching = _this$context$state.searching;

      var handleControlledSourceItms = function handleControlledSourceItms() {
        var _getActiveIdFromHiera = getActiveIdFromHierarchy(hierarchy),
            id = _getActiveIdFromHiera.id;

        if (id) {
          return filterBySearch(searchTerm, searching)(getChildrenFromParent(id)(nonSelectedItems.map(function (it) {
            return items.find(function (itt) {
              return itt.id === it;
            });
          })));
        }

        return filterBySearch(searchTerm, searching)(items.filter(function (it) {
          return nonSelectedItems.some(function (itt) {
            return itt === it.id && !nonSelectedItems.some(function (ittt) {
              return ittt === it.parent;
            });
          });
        }));
      };

      var composedSourceItems; // controlled V2 TODO make it default controlled behavior

      if (nonSelectedItems) {
        composedSourceItems = handleControlledSourceItms();
      } else {
        composedSourceItems = compose(filterBySearch(searchTerm, searching), filterMovedItems(movedItems), getChildrenFromParent(getActiveIdFromHierarchy(hierarchy).id))(items);
      }

      var handleControlledTargetItms = function handleControlledTargetItms() {
        var _getActiveIdFromHiera2 = getActiveIdFromHierarchy(hierarchyDest),
            id = _getActiveIdFromHiera2.id;

        if (id) {
          return getChildrenFromParent(getActiveIdFromHierarchy(hierarchyDest).id)(_this6.props.selectedItems.map(function (it) {
            return items.find(function (itt) {
              return itt.id === it;
            });
          }));
        }

        return targetItems.filter(function (it) {
          return _this6.props.selectedItems.some(function (itt) {
            return itt === it.id && !_this6.props.selectedItems.some(function (ittt) {
              return ittt === it.parent;
            });
          });
        });
      };

      var composedTargetItems; // controlled V2 TODO make it default controlled behavior

      if (nonSelectedItems) {
        composedTargetItems = handleControlledTargetItms();
      } else {
        composedTargetItems = compose(function (tItems) {
          var hierarchyId = getActiveIdFromHierarchy(hierarchyDest).id;
          return hierarchyId ? compose(filterMovedItems(movedItems), getChildrenFromParent(hierarchyId))(tItems) : movedItems;
        })(targetItems);
      }

      return /*#__PURE__*/React.createElement(ShuttleRenderer, _extends({}, rest, {
        moreItemsLoading: moreItemsLoading,
        checkedItems: checkedItems,
        hierarchy: hierarchy,
        hierarchyDest: hierarchyDest,
        onCheckItem: this.toggleItemSelection,
        onClearCheckedItems: this.resetCheckedItems,
        onClearMovedItems: this.resetMovedItems,
        onItemCheck: this.toggleItemSelection,
        onMoveCheckedItems: this.moveCheckedItems,
        onMoveItemToSource: function onMoveItemToSource(item) {
          return _this6.removeFromTarget(item, false);
        },
        onMoveItemToTarget: function onMoveItemToTarget(item) {
          return _this6.addToTarget(item, true);
        },
        onNavigateOnSourceTo: function onNavigateOnSourceTo(item, direction) {
          return _this6.navigate(item, false, direction);
        },
        onNavigateOnTargetTo: function onNavigateOnTargetTo(item, direction) {
          return _this6.navigate(item, true, direction);
        },
        onSourceSortEnd: function onSourceSortEnd() {
          return null;
        },
        onTargetSortEnd: this.handleTargetSortEnd,
        sourceItems: composedSourceItems,
        targetItems: composedTargetItems
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return updateShuttleStateFromProps(nextProps, prevState);
    }
  }]);

  return ShuttleImpl;
}(Component);

_defineProperty(ShuttleImpl, "contextType", SearchState.Context);

var ShuttleImpl$1 = withProviders(ShuttleImpl);

export default ShuttleImpl$1;
//# sourceMappingURL=ShuttleImpl.js.map
